import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import PagesControl from '../../../components/library/pages/PagesControl';

const OfficeListPages = ({ officeList, onSetOffset }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [lastPage, setLastPage] = useState(-1)

    useEffect(() => {
        var o = Number(officeList.offset);
        var totalCount = Number(officeList.totalCount);
        var limit = Number(officeList.limit);

        if (o >= 0 && totalCount > 0 && limit > 0) {
            setCurrentPage(Math.floor(o / limit));
            setLastPage(Math.ceil(totalCount / limit) - 1)
        }
    }, [officeList.offset, officeList.totalCount, officeList.limit])

    const handleSetPage = (page) => {
        if (page !== currentPage) {
            onSetOffset(page * officeList.limit)
        }
    }

    return (
        <div className="columns">
            <div className='column is-12'>
                <div className='page-ctrl'>
                    <PagesControl currentPage={currentPage} maxPage={lastPage} onSetPage={handleSetPage} />
                </div>
            </div>
        </div>
    );
}

OfficeListPages.propTypes = {
    officeList: PropTypes.object.isRequired,
    onSetOffset: PropTypes.func.isRequired
}

export default OfficeListPages